import { render, staticRenderFns } from "./AttributeList.vue?vue&type=template&id=6d863359&scoped=true"
import script from "./AttributeList.vue?vue&type=script&lang=js"
export * from "./AttributeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d863359",
  null
  
)

export default component.exports